import { render } from "./ProductAttachProjectComponent.vue?vue&type=template&id=739b7ce8"
import script from "./ProductAttachProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProductAttachProjectComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__